import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import waterfall from "@/assets/phnom-kulen-waterfall-tour.jpg";


const schedule = [
  { time: "7:30 AM", title: "Hotel Pickup", body: "Hotel pickup in Siem Reap in a comfortable, air-conditioned vehicle." },
  { time: "9:30 AM", title: "Arrival at Kulen Mountain", body: "Arrive at Phnom Kulen National Park and begin your sacred mountain exploration." },
  { time: "10:00 AM", title: "Giant Buddha (Preah Ang Thom)", body: "Visit one of Cambodia's most sacred Buddha statues, carved from a single massive sandstone boulder atop the mountain." },
  { time: "11:00 AM", title: "1000 Lingas at Kbal Spean", body: "Explore the ancient riverbed carvings intricate Hindu lingas and deities sculpted directly into the stone beneath flowing water." },
  { time: "12:30 PM", title: "Lunch Break", body: "Lunch break at a local restaurant (own expense)." },
  { time: "1:30 PM", title: "Kulen Waterfall", body: "Visit and swim at the beautiful Kulen Waterfall bring your swimwear and enjoy the cool jungle pools." },
  { time: "4:00 PM", title: "Return to Siem Reap", body: "Begin the scenic drive back through rural Cambodian countryside." },
  { time: "5:30 – 6:00 PM", title: "Hotel Drop-off", body: "Arrive back at your hotel with unforgettable memories." },
];

const TourPhnomKulen = () => {
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={waterfall}
          alt="Phnom Kulen waterfall private tour from Siem Reap with French-speaking guide, sacred mountain Cambodia"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70 hidden sm:inline">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— One Day Sojourn</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              Phnom Kulen Waterfall, Buddha &amp; 1000 Lingas.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              Explore the sacred beauty of Phnom Kulen National Park a giant Reclining Buddha, ancient river carvings, and a stunning jungle waterfall.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · ~10 Hours</span>
              <span>Group · 2–15</span>
              <span>From $35 / pax</span>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Sacred Mountain</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-10 text-balance">
            A full-day pilgrimage into Cambodia's holiest mountain.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              Discover the spiritual highlights of Phnom Kulen, including the famous Kbal Spean where ancient lingas lie carved beneath a flowing riverbed.
            </p>
            <p>
              Visit the impressive Preah Ang Thom, one of Cambodia's most sacred Buddha statues, before relaxing at the beautiful Kulen Waterfall, where you can swim and enjoy nature.
            </p>
            <p className="text-base text-muted-foreground/80 italic">
              Tour Phnom Kulen prix transparent, accompagné par un guide francophone à Siem Reap et un chauffeur privé au Cambodge.
            </p>
          </div>
        </div>
      </section>


      {/* TIMELINE */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Tour Schedule</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            What you will do, hour by hour.
          </h2>
          <ol className="relative border-l border-border pl-8 md:pl-10 space-y-12">
            {schedule.map((s) => (
              <li key={s.time} className="relative">
                <span className="absolute -left-[41px] md:-left-[49px] top-1 h-3 w-3 rounded-full bg-primary ring-4 ring-background" />
                <p className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{s.time}</p>
                <h3 className="font-display text-2xl md:text-3xl mb-3">{s.title}</h3>
                <p className="text-muted-foreground font-light leading-relaxed text-lg">{s.body}</p>
              </li>
            ))}
          </ol>
        </div><BookingSidebar pricePerPerson={145} tourTitle="Phnom Kulen &nbsp;Waterfall, Buddha & 1000 Lingas" pricingTiers={[{ maxPax: 2, price: 145 }, { maxPax: 6, price: 175 }, { maxPax: 10, price: 225 }]} /></div></div>
      </section>

      {/* PRICE */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Price</p>
          <ul className="space-y-4 font-light text-lg">
            <li className="border-b border-border pb-4 flex justify-between"><span>Private Tour (1–2 pax)</span><span>$85 – $100</span></li>
            <li className="border-b border-border pb-4 flex justify-between"><span>Group Tour</span><span>$35 – $70 / person</span></li>
            <li className="pb-4 flex justify-between"><span>Kulen Entrance Fee</span><span>$20 / person</span></li>
          </ul>
        </div>
      </section>

      {/* INCLUDED / NOT INCLUDED */}
      <section className="py-24 md:py-32">
        <div className="container max-w-5xl grid md:grid-cols-2 gap-x-12 gap-y-12">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— What's Included</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Air-conditioned transport with hotel pickup &amp; drop-off</li>
              <li className="border-b border-border pb-4">Professional English-speaking guide</li>
              <li className="border-b border-border pb-4">Complimentary bottled water</li>
              <li className="border-b border-border pb-4">Refreshing cold towels</li>
              <li className="pb-4">Photography guidance for the best angles &amp; lighting</li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Not Included</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">All meals</li>
              <li className="pb-4">Kulen entrance fee US $20 per person</li>
            </ul>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Flashlight or phone light</li>
                <li>Modest clothing shoulders &amp; knees covered</li>
                <li>Comfortable walking shoes</li>
                <li>Swimwear &amp; quick-dry towel</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small backpack</li>
                <li>Cash for lunch</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>Pickup time: 7:30 – 8:00 AM (exact time confirmed the day before). Tour ends 5:30 – 6:00 PM.</p>
            <p>Dress code: casual but respectful  covered shoulders and knees required inside temples. Comfortable walking shoes strongly recommended. For safety, leave valuables at your hotel.</p>
            <p>This tour is not wheelchair accessible. Children under 5 are not permitted. Maximum group size: 2–15 travellers in an air-conditioned vehicle.</p>
            <p>Phnom Kulen tours are most popular in the dry season (November to March) and tend to sell out quickly. We recommend booking at least 48 hours in advance.</p>
            <p>
              <span className="text-foreground">Weather.</span> Hot and dry throughout. Possibility of a brief shower, but mostly dry. Midday is hot, though woodland sites have low humidity.
            </p>
            <p>
              <span className="text-foreground">Food.</span> Khmer cuisine is similar to most Southeast Asian cooking, but less spicy. Good bread is widely available thanks to the French influence, with a surprisingly wide range of local brews to try.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Reserve Your Day</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            A sacred mountain awaits.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourPhnomKulen;
